var idioma = $('html').attr('lang');
$('.houdiniForm').each(function() {//per cada formulari
    'use strict';
    //validacio formulari
    $(this).validate({
        errorPlacement: function(error, element) {
            if (element.attr('type') === 'checkbox' || element.attr('type') === 'radio') {
                if (element.closest('div').find('input').length > 1) {
                    error.insertAfter(element.closest('div').find('p.type-label'));
                } else {
                    error.insertAfter(element.parent('label'));
                }
            } else {
                error.insertAfter(element);
            }
        }
    });
    var others = $(this).find('option[value="others_field"]');
    others.each(function(){
        $(this).closest('div').find('input[type="text"]').hide();
        $(this).closest('div').find('select').on('change', function(){
            if ($(this).closest('div').find('select').val() == 'others_field') {
                $(this).closest('div').find('input[type="text"]').show();
            } else {
                $(this).closest('div').find('input[type="text"]').hide().val('');
            }
        });
    });
});

//datapicker

$('.houdiniForm .hasDatepicker').fdatepicker({language: idioma, format: 'dd/mm/yyyy'});

//chosen
$('.houdiniForm .chzn-select').select2();
$('.multiple-select-help').hide(); //amaga misatge d'ajuda dels selects multiples
$('.chzn-select').select2();

$.fn.raty.defaults.path = '/media/img';
$.fn.raty.defaults.cancel = false;

//valoracio
$('.houdiniForm .scoreField').each(function() {
    'use strict';
    var field = $(this);
    var id = '#' + field.attr('id');
    var score = $('<div></div>');
    score.raty({
        half: true,
        hints: ['', '', '', '', ''],
        score: function() {
            return field.val();
        },
        targetScore: id
    });
    field.hide();
    field.after(score);
});

//select de dnis
$('.houdiniForm .dninifnie').each(function() {
    'use strict';
    $(this).find('select').on('change', function() {
        var value = $(this).val();
        var input = $(this).closest('div.row').find('input');

        if (value === 'DNI') {
            input.rules('add', {
                dni: true,
                cifES: false,
                nieES: false
            });
        } else if (value === 'CIF') {
            input.rules('add', {
                dni: false,
                cifES: true,
                nieES: false
            });
        } else if (value === 'NIE') {
            input.rules('add', {
                dni: false,
                cifES: false,
                nieES: true
            });
        }
    });
});

$('.houdiniForm .import').each(function() {
    var inputTotal = $(this).find('.total input');
    var textTotal = $(this).find('.total .text');
    inputTotal.val(0);
    textTotal.html(0);
    if($(this).data('importtype') == 'multicheck'){
        $(this).find('input[type="checkbox"]').each(function(){
            var valor = $(this).val();
            var sum = Number(inputTotal.val());
            if($(this).is(':checked')){
                sum = Number(inputTotal.val()) + Number(valor);
                inputTotal.val(sum);
                textTotal.html(sum);
            }
        });
        $(this).find('input[type="checkbox"]').on('change', function(elem) {
            var valor = $(this).val();
            if($(this).is(':checked')){
                var sum = Number(inputTotal.val()) + Number(valor);
            } else {
                var sum = Number(inputTotal.val()) - Number(valor);
            }
            if(sum < 0){
                sum = 0;
            }
            inputTotal.val(sum);
            textTotal.html(sum);
        });
    }
    if($(this).data('importtype') == 'multiselect'){
        var select = $(this).find('select')
        var valor = select.val();
        var sum = 0;
        $.each(valor,function(){sum+=parseFloat(this) || 0;});
        textTotal.html(sum);
        inputTotal.val(sum);
        select.on('change', function(elem) {
            $(this).each(function() {
                var sum = 0;
                var valor = $(this).val();
                $.each(valor,function(){sum+=parseFloat(this) || 0;});
                inputTotal.val(sum);
                textTotal.html(sum);
            });
        });
    }
    if($(this).data('importtype') == 'simpleselect'){
        var select = $(this).find('select');
        textTotal.html(select.val());
        inputTotal.val(select.val());
        select.on('change', function(elem) {
            $(this).each(function() {
                var valor = $(this).val();
                inputTotal.val(valor);
                textTotal.html(valor);
            });
        });
    }
    if($(this).data('importtype') == 'simple'){
        textTotal.html($(this).find('input[type="radio"]:checked').val());
        inputTotal.val($(this).find('input[type="radio"]:checked').val());
        $(this).find('input[type="radio"]').on('change', function(elem) {
            var valor = $(this).val();
            inputTotal.val(valor);
            textTotal.html(valor);
        });
    }
});
